module.exports = __webpack_public_path__ + "img/luchador-mask.999fea83.svg";